import { useEffect, useState } from 'react';
import { FiArrowLeft, FiArrowRight, FiStar } from 'react-icons/fi';
import avatar1 from '../assets/slider/1.jpg';
import avatar2 from '../assets/slider/2.jpg';
import avatar3 from '../assets/slider/3.jpg';
import './Testimonials.css';

const testimonials = [
  {
    id: 1,
    avatar: avatar1,
    rating: 5,
    quote: 'My dog moves so much better now! Trillium Paws Hip & Joint really makes a difference. He is running up the porch steps again with zero hesitation.',
    name: 'Sarah M.',
    petName: 'Cooper',
    petAge: 9,
  },
  {
    id: 2,
    avatar: avatar2,
    rating: 5,
    quote: 'Great quality products and ultra-fast shipping. My pup is notoriously picky with pills, but he actually sits and begs for these chews like treats!',
    name: 'James L.',
    petName: 'Buster',
    petAge: 3,
  },
  {
    id: 3,
    avatar: avatar3,
    rating: 5,
    quote: 'Finally a brand that truly cares about pets and clean formulas. The allergy chew completely stopped her paw-licking within 2 weeks. Highly recommend!',
    name: 'Emily R.',
    petName: 'Daisy',
    petAge: 5,
  },
  {
    id: 4,
    avatar: avatar1,
    rating: 5,
    quote: 'The clean ingredients gave me confidence, and my senior girl has so much more pep in her step. We are both very happy with the results.',
    name: 'Rachel K.',
    petName: 'Molly',
    petAge: 11,
  },
  {
    id: 5,
    avatar: avatar2,
    rating: 5,
    quote: 'These are the first wellness chews my dog finishes every single day. The quality, packaging, and customer care are all excellent.',
    name: 'Daniel P.',
    petName: 'Milo',
    petAge: 4,
  },
  {
    id: 6,
    avatar: avatar3,
    rating: 5,
    quote: 'Her coat looks healthier and she is much less itchy. I love knowing exactly what is in every chew she gets.',
    name: 'Lauren T.',
    petName: 'Ruby',
    petAge: 6,
  },
];

function Stars({ rating }) {
  return (
    <div className="testimonials__rating">
      <span className="visually-hidden">Rated {rating} out of 5 stars</span>
      <span aria-hidden="true">
        {Array.from({ length: 5 }).map((_, index) => <FiStar className={index < rating ? 'is-filled' : ''} key={index} />)}
      </span>
    </div>
  );
}

export default function Testimonials() {
  const [currentPage, setCurrentPage] = useState(0);
  const cardsPerPage = 3;

  const pageCount = Math.max(1, Math.ceil(testimonials.length / cardsPerPage));
  const safePage = Math.min(currentPage, pageCount - 1);
  const pages = Array.from({ length: pageCount }, (_, pageIndex) => testimonials.slice(pageIndex * cardsPerPage, (pageIndex + 1) * cardsPerPage));

  useEffect(() => {
    if (currentPage >= pageCount) setCurrentPage(pageCount - 1);
  }, [currentPage, pageCount]);

  return (
    <section className="testimonials" aria-labelledby="testimonials-heading">
      <div className="header-container testimonials__container">
        <div className="testimonials__header-row">
          <header className="testimonials__header">
            <p className="testimonials__eyebrow">COMMUNITY LOVE</p>
            <h2 id="testimonials-heading">Real Stories. Real Results.</h2>
            <p>Trusted by thousands of dog lovers across the country.</p>
          </header>
          <div className="testimonials__controls">
            <a className="testimonials__reviews-link" href="#reviews">Read More Reviews <FiArrowRight aria-hidden="true" /></a>
            <button type="button" aria-label="Previous testimonials" disabled={safePage === 0} onClick={() => setCurrentPage(page => Math.max(0, page - 1))}><FiArrowLeft aria-hidden="true" /></button>
            <button type="button" aria-label="Next testimonials" disabled={safePage === pageCount - 1} onClick={() => setCurrentPage(page => Math.min(pageCount - 1, page + 1))}><FiArrowRight aria-hidden="true" /></button>
          </div>
        </div>

        <div className="testimonials__viewport">
          <div className="testimonials__track" style={{ transform: `translateX(-${safePage * 100}%)` }}>
            {pages.map((page, pageIndex) => (
              <div className="testimonials__page" key={pageIndex} aria-hidden={safePage !== pageIndex}>
                {page.map(testimonial => (
                  <article className="testimonials__card" key={testimonial.id}>
                    <Stars rating={testimonial.rating} />
                    <blockquote>&ldquo;{testimonial.quote}&rdquo;</blockquote>
                    <div className="testimonials__divider" aria-hidden="true" />
                    <div className="testimonials__profile">
                      <span className="testimonials__avatar" aria-hidden="true">{testimonial.name.charAt(0)}</span>
                      <cite>
                        <strong>{testimonial.name}</strong>
                        <span className="testimonials__verified">VERIFIED BUYER</span>
                        <span className="testimonials__pet">(Dog: {testimonial.petName}, {testimonial.petAge} yrs)</span>
                      </cite>
                    </div>
                  </article>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
